import {
  V2ListUsersForAccountApiArg,
  useV2ListUsersForAccountQuery,
} from "@generated";
import { User } from "../types";

export interface HookArgs {
  page?: V2ListUsersForAccountApiArg["page"];
  filter?: V2ListUsersForAccountApiArg["filter"];
}

const useListUsersOnAccount = ({ page, filter }: HookArgs) => {
  const { data, error, isLoading, refetch } = useV2ListUsersForAccountQuery({
    include: [],
    page,
    filter,
  });

  let users: User[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      users = data.data.map((user) => {
        if (!user.id) {
          throw new Error("Missing user.id");
        }

        return {
          id: user.id,
          name: user.attributes.name,
        };
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return { users, error: error || customError, isLoading, pageMeta, refetch };
};

export default useListUsersOnAccount;
